<template>
  <div>
    <apexchart
      v-if="series.length"
      type="line"
      height="500"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div 
      v-else 
      class="d-flex justify-center align-center titleText--text text-capitalize font-weight-bold ml-3" 
      style="height: 300px">
      <span>No data</span>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    inputdata: null,
    isShowchart: null,
  },
  data: () => ({
    series: [],
    chartOptions: null,
    Chartdata:[],
    seriesData: null
  }),
  methods: {
    onloadCall(){
      alert('mixchart on load call');
    },
    loadchart(vardata) {
      let tempdata=[];
      tempdata=vardata;
      this.seriesdata = tempdata.filter(item => item.cpp > 0 || item.effective_frequency > 0);

      console.log('seriesData', vardata)

      this.series = [];

      let newseries_cpp = [];
      let newseries_effective_frequency = [];
      let chartcategories = [];

      for (let index = 0; index < this.seriesdata.length; index++) {
        newseries_cpp.push(this.seriesdata[index].cpp);
        newseries_effective_frequency.push(
          this.seriesdata[index].effective_frequency
        );
        chartcategories.push(this.seriesdata[index].column);
      }
      this.series = [
        {
          name: "CPP",
          type: "column",
          data: newseries_cpp.filter(val => val > 0),
        },
        {
          name: " Effective Frequency",
          type: "column",
          data: newseries_effective_frequency.filter(val => val > 0),
        },
      ];
      //chartOptions
      this.chartOptions = {
        chart: {
          height: 500,
          type: "bar",
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 1,
            barHeight: '50%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [1, 1],
        },
        xaxis: {
          categories: chartcategories,
          labels: {
            style: {
              colors: '#9AA1A9',
              fontWeight: 'bold'
            },
            formatter: (val) => {
              if (val && val.length > 15) {
                return val.slice(0, 15) + '...'
              } else {
                return val
              }
            }
          }
        },
        yaxis: [
          
          { 
            axisTicks: {
              show: false,
            },
            labels: {
            style: {
              colors: ["#9AA1A9"],
              fontWeight: 'bold'
            },
            formatter: (val) => Intl.NumberFormat("en-US").format(val)
          },
            title: {
              text: "CPP",
              style: {
                color: "#9AA1A9",
              },
            },
          },
          {
            seriesName: "Income",
            opposite: true,
            axisTicks: {
              show: false,
            },
            labels: {
              formatter: (val) => Intl.NumberFormat("en-US").format(val),
            style: {
              colors: ["#9AA1A9"],
              fontWeight: 'bold'
            },
          },
            title: {
              text: "Effective Frequency",
              style: {
                color: "#9AA1A9",
              },
            },
          },
        ],
        tooltip: {
        inverseOrder: true,
        x: {
          show: true,
          formatter: (val) => {
            return this.seriesdata[val - 1].column
          }
        },
        },
        legend: {
          fontWeight: 'bold',
          labels: {
            colors: '#9AA1A9',
          }
        },
      };
    },
  }
};
</script>
